import * as React from 'react'

interface IOption {
  label: string
  value: string
}

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: IOption[]
}

const Dropdown = (props: IProps) => {
  const { options, ...rest } = props

  return (
    <select {...rest}>
      {options.map(option => {
        return (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )
      })}
    </select>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ./client/components/dropdown.tsx